var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOther(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 147.64 135.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#7da2fe;}.cls-3{opacity:.5;}.cls-4{fill:url(#linear-gradient);stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -85.03,
    y1: 924.46,
    x2: -30.33,
    y2: 869.77,
    gradientTransform: "translate(782.6 -498.25) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.86,55.78l-52.14,52.14-2.51,8.94-.28,1.01c-1.14,.08-2.28,.11-3.44,.11C27.19,117.98,1,91.79,1,59.49S27.19,1,59.49,1s56.46,24.21,58.37,54.78Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.49,0C26.69,0,0,26.69,0,59.49s26.69,59.49,59.49,59.49c1.06,0,2.1-.03,3.15-.09l.29-1.02,.28-1.01c-1.23,.08-2.47,.12-3.72,.12-31.7,0-57.49-25.79-57.49-57.49S27.79,2,59.49,2s55.97,24.3,57.43,54.72l1.88-1.88C116.42,24.2,90.73,0,59.49,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.88,
    cy: 59.49,
    r: 9.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 59.49,
    cy: 59.49,
    r: 9.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 87.11,
    cy: 59.49,
    r: 9.36
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M144.81,72.98l-55.16,55.16-20.86,5.85,5.85-20.86,55.16-55.16c1.77-1.77,4.66-1.77,6.43,0l8.57,8.57c1.77,1.77,1.77,4.66,0,6.43Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.a792fc5550b2aa778670f89b78b0e650.svg";
export { ForwardRef as ReactComponent };